const X = ({ width = 24, height = 24, fill = '#CECFD4', ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.9389 4.31677H19.5457L13.8507 10.8258L20.5504 19.6832H15.3046L11.1958 14.3113L6.49447 19.6832H3.88611L9.97752 12.721L3.55042 4.31677H8.92945L12.6434 9.22694L16.9389 4.31677ZM16.024 18.1229H17.4685L8.14458 5.7951H6.59454L16.024 18.1229Z" />
    </svg>
  );
};

export default X;
